import { ChangeDetectorRef, Component, Input } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import {firstValueFrom} from 'rxjs';

import { first } from 'rxjs/operators';

import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';
import { ClassName } from '@sim/role';

import { SwalService } from '@atmi/core';
import { Restoration, RestorationMeta } from '@atmi/core/models';
import { RestorationDialogComponent } from '@atmi/shared/restoration-dialog/restoration-dialog.component';

@Component({
  selector: 'app-restorations-manager',
  styleUrls: ['./restorations-manager.component.scss'],
  templateUrl: './restorations-manager.component.html',
})
export class RestorationsManagerComponent extends BaseCtrlValueAccessorFormArrayComponent<Restoration> {

  @Input() classNames: ClassName[] = [];

  get restorations() {
    return this.value;
  }

  constructor(
    private readonly translate: TranslateService,
    private readonly dialog: MatDialog,
    private readonly swal: SwalService,
    private readonly formManager: FormManagerService,
    private readonly cd: ChangeDetectorRef,
  ) {
    super();
  }

  orderRestorationHandler(items: Restoration[]) {
    if (!this.form) {
      throw new Error('Cannot order without a form');
    }
    const form = this.form;
    const value: Restoration[] = form.value;
    const pathcValue = value.map((_, i) => items[i]);

    this.form.controls.forEach((_, i) => {
      const control = this.formManager.makeForm(RestorationMeta, pathcValue[i]);
      form.setControl(i, control);
    });

    this.cd.markForCheck();
  }

  async addRestorationHandler() {
    const ref = this.dialog.open(RestorationDialogComponent, { data: {}, width: '784px' });
    const res: Restoration | undefined = await firstValueFrom(ref.afterClosed().pipe(first()));

    if (res && this.form) {
      const group = this.formManager.makeForm(RestorationMeta, res);
      this.form.push(group);

      this.cd.markForCheck();
    }
  }

  async editRestorationHandler(restoration: Restoration, index: number) {
    const ref = this.dialog.open(RestorationDialogComponent, { data: { restoration }, width: '784px' });
    const res = await firstValueFrom(ref.afterClosed().pipe(first()));

    if (res && this.form) {
      const form = this.form;
      const value: Restoration[] = form.value;
      const pathcValue = value.map((item, i) => i === index ? res : item);

      this.form.controls.forEach((_, i) => {
        const control = this.formManager.makeForm(RestorationMeta, pathcValue[i]);
        form.setControl(i, control);
      });

      this.cd.markForCheck();
    }
  }

  async removeRestorationHandler(index: number) {
    const res = await this.swal.showConfirm({
      text: this.translate.instant('Sei sicuro di voler rimuovere questo restauro?'),
      title: this.translate.instant('Rimozione restauto'),
    });

    if (res) {
      if (res && this.form) {
        this.form.removeAt(index);

        this.cd.markForCheck();
      }
    }
  }
}
